// eslint-disable-next-line import/prefer-default-export
export const RETRIEVE_POSTAL_CODES = 'commercial/postalCodes/retrieve';
export const RETRIEVE_POSTAL_CODE = 'commercial/postalCodes/getById';
export const FLUSH_POSTAL_CODE = 'commercial/postalCodes/flush';
